import { lazy } from 'react';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';

const UserPositionHistory = lazy(() => import('./userPositionHistory/screens/UserPositionHistory'));

const routesRoutes = [
  {
    component: UserPositionHistory,
    path: PATHS.USER_POSITIONS_HISTORY,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.USER_POSITION_HISTORY.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routesRoutes;
